module.exports = __webpack_public_path__ + "static/media/portrait (2).1e785d43.jpg";